module.exports = __webpack_public_path__ + "static/media/color-white.20d5603b.svg";